import type { SiteConfig } from "./gboModels";

const embeddedSiteConfigId = "gbo-site-config";

export function readEmbeddedSiteConfig(documentRef: Document = document): SiteConfig | null {
  const element = documentRef.getElementById(embeddedSiteConfigId);
  if (!element?.textContent) return null;

  try {
    return JSON.parse(element.textContent) as SiteConfig;
  } catch {
    return null;
  }
}
